import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=1c72efbe"
import script from "./treaty.vue?vue&type=script&lang=js"
export * from "./treaty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports